import { useCallback } from 'react'

import { Text } from '@ds'
import { GalaxyButton, Privacy, Terms } from '@shared'
import { useOverlayActions, useUserActions } from '@store'

import styles from './AcceptPrivacy.module.scss'

export const AcceptPrivacy = () => {
  const { acceptPolicy } = useUserActions()
  const { hideOverlay } = useOverlayActions()

  const handleAccept = useCallback(() => {
    acceptPolicy().then(() => {
      hideOverlay()
    })
  }, [acceptPolicy, hideOverlay])

  return (
    <div className={styles.container}>
      <div className={styles.contentCard}>
        <div className={styles.content}>
          <Terms noScroll />
          <Privacy noScroll />
        </div>
        <div className={styles.buttonContainer}>
          <GalaxyButton
            onClick={handleAccept}
            className={styles.button}
            withGlow={false}
          >
            <Text type="body" center>
              I Agree
            </Text>
          </GalaxyButton>
        </div>
      </div>
    </div>
  )
}
